require("es6-symbol/implement");
// import AOS from "aos";
import "aos/dist/aos.css";
import SmoothScroll from "smooth-scroll";
import accordion from "./accordion";
import lottie from "lottie-web";
import Flickity from "flickity-as-nav-for";
import Isotope from "isotope-layout";
import { xor } from "lodash";
import { CountUp } from "countup.js";


function countUpElements() {
  const insts = [...document.querySelectorAll(".countup")].map(
    (el) => new CountUp(el, parseInt(el.getAttribute("data-final")))
  );
  document.addEventListener("aos:in:overspending", () =>
    insts.forEach((inst, i) => {
      setTimeout(() => inst.start(), i * 200);
    })
  );
}

function smoothScroll() {
  return new SmoothScroll('a[href*="#"]', {
    emitEvents: true, // Emit custom events
    topOnEmptyHash: false,
    header: "header.header",
  });
}

function headerScroll() {
  const header = document.querySelector(".header");
  window.addEventListener(
    "scroll",
    () => {
      if (window.scrollY >= 30) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    },
    {
      passive: true,
    }
  );
}

function burgerClick() {
  const hb = document.querySelector(".tg-hamburger");
  hb &&
    hb.addEventListener("click", () => {
      document.body.classList.toggle("nav-open");
    });
}

function lottieAnimations() {
  lottie.searchAnimations();

  if (document.querySelector(".page--hiw")) {
    (function scrollAnimations() {
      const anims = {};
      for (const item of lottie.getRegisteredAnimations()) {
        anims[item.name] = item;
      }

      [...document.querySelectorAll(".steps [data-aos-id]")].forEach((el) => {
        const name = el.getAttribute("data-aos-id");
        document.addEventListener(`aos:in:${name}`, ({ detail }) => {
          if (anims[name]) {
            anims[name].goToAndPlay(0);
          }
        });
      });
    })();

    const segments = [0, 790, 1360, 2000, 3000];
    const buttons = [...document.querySelectorAll(".animation-buttons button")];

    const prefix = window.location.pathname.includes('_TGA') ? '/_TGA' : '';
    const ani = lottie.loadAnimation({
      container: document.querySelector(".hiw-animation"),
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: `${prefix}/wp-content/themes/theme/dist/animations/hiw-masthead.json`, // the path to the animation json
    });

    ani.addEventListener("enterFrame", () => {
      const frame = ani.currentFrame;
      function getClosestSegment(frame) {
        let i = 0;
        while (segments[++i] < frame);
        return segments[--i];
      }

      const activeSegment = getClosestSegment(frame);

      buttons.forEach((btn) => btn.classList.remove("is-active"));

      buttons[segments.indexOf(activeSegment)].classList.add("is-active");
    });

    buttons.forEach((button, i) => {
      button.addEventListener("click", () => {
        buttons.forEach(
          (btn) => btn !== button && btn.classList.remove("is-active")
        );
        button.classList.add("is-active");
        ani.goToAndPlay(segments[i], true);
      });
    });
  }
}

function subnavThumbs() {
  const hideAllThumbs = (active = null) => {
    [...document.querySelectorAll(".menu-graphic")].slice(1).forEach((item) => {
      if (item === active) {
        item.classList.remove("opacity-0");
      } else {
        item.classList.add("opacity-0");
      }
    });
  };

  document
    .querySelector("[data-menu=services]")
    .addEventListener("mouseleave", hideAllThumbs);

  [...document.querySelectorAll("a[data-thumb]")].forEach((el) => {
    const thumbStr = el.getAttribute("data-thumb");
    const match = document.querySelector(
      `.menu-graphic[data-thumb='${thumbStr}']`
    );

    el.addEventListener("mouseenter", () => {
      hideAllThumbs(match);
    });
  });
}

function servicesSlider() {
  const serviceItems = document.querySelector('.service-items');
  if (!serviceItems) return;
  window.currentShown = 0;
  const sectionTimeout = 10000;
  const sliders = [];
  serviceItems.children[0].classList.add('is-shown');
  window.servicesClicked = false;

  serviceItems.addEventListener('click', (e)=>{
    stopProgress();
  });

  function stopProgress() {
    window.servicesClicked = true;
    const el = document.querySelector('.services-menu');
    if (sliderInterval) clearInterval(sliderInterval);
    if (el) {
      el.classList.add('is-clicked');
    }
  }

  [...serviceItems.children].forEach((service) => {
    const slider = new Flickity(service.querySelector('.service-item-slider'), {
      adaptiveHeight: true,
      asNavFor: service.querySelector('.service-item-slider'),
    });

    const sliderNav = new Flickity(
      service.querySelector('.service-item-slider-nav'),
      {
        asNavFor: service.querySelector('.service-item-slider'),
        contain: true,
        adaptiveHeight: true,
        pageDots: false,
        prevNextButtons: false,
      }
    );

    sliders.push(slider);
    sliders.push(sliderNav);

    setTimeout(() => {
      sliderNav.reposition();
    }, 500);
  });

  function showSlide(showIndex) {
    window.currentShown = parseInt(showIndex);
    [...document.querySelector(".service-items").children].forEach(
      (ser, index) => {
        if (showIndex == index) {
          ser.classList.remove("opacity-0");
          ser.classList.remove("absolute");
          ser.classList.remove("pointer-events-none");
          ser.classList.add("is-shown");
          if (sliders[index] && sliders[index + 1]) {
            sliders[index].reposition();
            sliders[index + 1].reposition();
          }
        } else {
          ser.classList.add("opacity-0");
          ser.classList.add("absolute");
          ser.classList.add("pointer-events-none");
          ser.classList.remove("is-shown");
        }
      }
    );
  }

  const clickItems = [
    ...document.querySelectorAll(".services-menu-items [data-slide]"),
  ];

  clickItems[0].classList.add('is-active');

  function intervalFunction() {
    clickItems.forEach((ci) => ci.classList.remove("is-active"));
    let val = currentShown + 1;
    if (clickItems.length === currentShown + 1) {
      val = 0;
    }
    clickItems[val].classList.add("is-active");
    showSlide(val);
  }

  window.sliderInterval = setInterval(() => {
    intervalFunction();
  }, sectionTimeout);

  clickItems.forEach((el) => {
    el.addEventListener("click", (e) => {

      stopProgress();

      // if (!servicesClicked) {
      //   sliderInterval = setInterval(() => {
      //     intervalFunction();
      //   }, sectionTimeout);
      // }
      clickItems.forEach((ci) => ci !== el && ci.classList.remove("is-active"));
      el.classList.add("is-active");
      showSlide(el.getAttribute("data-slide"));
    });
  });

  document
    .querySelector(".mobile-services-menu")
    .addEventListener("change", (e) => {
      const index = parseInt(e.currentTarget.value);
      showSlide(index);
    });
}

function servicesHeroSlider() {
  const el = document.querySelector(".slider-services-hero");
  if (!el) return;

  const slider = new Flickity(el, {
    wrapAround: true,
    autoPlay: true,
    contain: true,
    adaptiveHeight: true,
    pageDots: false,
    on: {
      ready() {
        document
          .querySelector(".service-hero__slider")
          .classList.remove("opacity-0");
      },
    },
  });
}

function benefitsSlider() {
  const el = document.querySelector(".benefits-slider");
  if (!el) return;

  window.bslider = new Flickity(el, {
    cellAlign: "left",
    contain: true,
    // adaptiveHeight: true,
    pageDots: true,
    on: {},
  });
}

function workListing() {
  const root = document.querySelector(".work-grid");
  if (!root) return;

  const elem = document.querySelector(".work-grid");
  const moreButton = document.querySelector(".load-more-button");
  window.showCount = 15;
  let filterTerms = [];

  const allLightboxes = () =>
    window.lgData && Object
      .keys(window.lgData)
      .filter((k) => k !== "uid")
      .map((k) => lgData[k]);

  const removeLightboxes = () =>
    allLightboxes().forEach((lb) => lb.destroy && lb.destroy(true));

  const currentLightbox = () => allLightboxes()[0];

  const addListeners = (i) => {
    removeLightboxes();
    setTimeout(() => {
      lightGallery(document.querySelector(".lightgallery"), {
        // mode:'lg-fade',
        download: false,
        dynamic: true,
        dynamicEl: window.filteredElements,
      });

      currentLightbox().index = i;
    }, 50);
  };

  function doLightbox() {

    removeLightboxes();

    const filtered = iso.filteredItems.map(({ element }) => {
      return {
        el: element,
        src: element.dataset.src,
        subHTML: element.dataset.subHtml,
      };
    });

    window.filteredElements = filtered;

    filtered.forEach(({el}, i) => {
      el.removeEventListener("click",addListeners.bind(this, i));
      el.addEventListener("click", addListeners.bind(this, i));
    });
  }

  window.iso = new Isotope(elem, {
    itemSelector: ".grid-item",
    layoutMode: "fitRows",
    percentPosition: true,
    initLayout: false,
  });

  iso.on("layoutComplete", () => {
    doLightbox();
  });

  iso.layout();

  const filters = [...document.querySelectorAll(".work-filter")];
  filters.forEach((filter) => {
    filter.addEventListener("change", ({ currentTarget: { name, value } }) => {
      const itm = name || value;
      if (itm === "#") {
        filterTerms = [];
      } else {
        filterTerms = xor(filterTerms, [itm]);
      }

      const filterName = filterTerms.length
        ? "." + filterTerms.join(", .")
        : "*";
      iso.arrange({ filter: filterName });

      iso.filteredItems
        .map(({ element }) => element)
        .forEach((el, i) => {
          if (i >= showCount) {
            el.classList.add("hidden");
          } else {
            el.classList.remove("hidden");
          }
        });

      iso.arrange();

      setTimeout(()=>{
        doLightbox();
      },200);

      if (iso.filteredItems.length <= showCount) {
        moreButton.classList.add("hidden");
      } else {
        moreButton.classList.remove("hidden");
      }
    });
  });

  moreButton.addEventListener("click", (e) => {
    const hiddenElems = iso.filteredItems
      .map(({ element }) => element)
      .filter((el) => el.classList.contains("hidden"));
    hiddenElems
      .slice(0, showCount)
      .forEach((itm) => itm.classList.remove("hidden"));
    iso.arrange();
    if (hiddenElems.length <= showCount) {
      moreButton.classList.add("hidden");
    }
  });
}

function mobileNav() {
  const haveSub = [...document.querySelectorAll(".has-sub")];
  haveSub.forEach((ni) => {
    const link = ni.querySelector(".sub-link");
    if (!link) return false;
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const toggle = e.currentTarget.querySelector(".transform");

      if (toggle.classList.contains("rotate-180")) {
        ni.querySelector(".subcontainer").classList.add("max-h-0");
        toggle.classList.remove("rotate-180");
      } else {
        ni.querySelector(".subcontainer").classList.remove("max-h-0");
        toggle.classList.add("rotate-180");
      }

      return false;
    });
  });
}

function designTypeSelect() {
  const select = document.querySelector(".design-type-select");
  if (!select) return;

  const hiddenField = document.querySelector("input[name=input_4]");
  if (hiddenField) {
    hiddenField.value = document.querySelector(
      `option[value=${select.value}]`
    ).innerText;
  }

  select.addEventListener("change", (e) => {
    const v = e.target.value;
    [...document.querySelectorAll(".is-dd")].forEach((el) => {
      if (el.classList.contains(v)) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });

    if (hiddenField) {
      hiddenField.value = document.querySelector(
        `option[value=${v}]`
      ).innerText;
    }
  });
}

function gallery() {
  [...document.querySelectorAll(".lightgallery-item")].forEach((el) => {
    el.addEventListener("click", function() {
      lightGallery(el, {
        dynamic: true,
        dynamicEl: galleryEls[el.getAttribute("data-galleryid")],
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll(".lightgallery").length) {
    require("lightgallery.js");
  }
  workListing();
  headerScroll();
  smoothScroll();
  servicesHeroSlider();
  lottieAnimations();
  benefitsSlider();
  accordion();
  burgerClick();
  subnavThumbs();
  servicesSlider();
  mobileNav();
  designTypeSelect();
  countUpElements();
});
